import { render } from "./NotFound.vue?vue&type=template&id=46ea8b8d&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=46ea8b8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ea8b8d"]])

export default __exports__